












































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { storePenunjang } from "@/store/modules/penunjang";
import moment from "moment";
import { orderBy } from "lodash";
import { getFormattedDateTime } from "@/utility/DateUtils";

@Component
export default class CardListPenunjang extends Vue {
  @Prop() title: string;
  @Prop() type: string;
  @Prop() listPenunjang: Array<object>;
  @Prop() panel: Array<object>;

  resepText = "";
  activeResep = {};
  selectedItem = null;
  selected = null;
  showModalLabResult = false;
  labResultActive = null;

  @Watch("showModalLabResult")
  changeShowModalLabResult(val) {
    if (!val) {
      this.labResultActive = null;
    }
  }

  mounted() {}

  get loading() {
    if (this.type === "lab") {
      return storePenunjang.loadingHasilLab;
    } else {
      return storePenunjang.loadingHasilRadiologi;
    }
  }

  get dtHasilRo() {
    return storePenunjang.hasilRadiologi;
  }
  get msgHasilRo() {
    return storePenunjang.msgHasilRadiologi;
  }

  get dtHasilLab() {
    return storePenunjang.hasilLabTrn;
  }
  get listItemPenunjang() {
    if (this.type === "ro") {
      return orderBy(
        this.listPenunjang,
        (item: any) => {
          return new Date(item.tgl);
        },
        ["desc"]
      );
    } else {
      return orderBy(
        this.listPenunjang,
        (item: any) => {
          return new Date(item.acc_date);
        },
        "desc"
      );
    }
  }

  getHumanDateTime(date) {
    return date
      ? moment(date, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm:ss")
      : "";
  }

  getHumanDate(date) {
    return date ? moment(date, "YYYY-MM-DD").format("DD-MM-YYYY") : "";
  }

  getDateTime(date, toFormat) {
    return getFormattedDateTime(date, toFormat);
  }

  getHasil(list, item) {
    let paramHasil: {};

    if (this.type == "ro") {
      paramHasil = {
        no_transaksi: list.no_transaksi,
        tgl: list.tgl,
        kode: item.kode,
        tipe: "ro"
      };
      this.selected = item;
    } else {
      paramHasil = {
        no_transaksi: list.no_transaksi,
        tgl: list.tgl,
        kode: item.kode,
        tipe: "lab"
      };
      this.selected = item;
    }

    this.$emit("detailHasil", paramHasil);
  }
  klikPanel() {
    storePenunjang.clear_hasil_ro();
    this.selected = null;
  }
  ganti() {
    this.selectedItem = null;
  }

  stripRtf(str) {
    const basicRtfPattern = /\{\*?\\[^{}]+;}|[{}]|\\[A-Za-z]+\n?(?:-?\d+)?[ ]?/g;
    const newLineSlashesPattern = /\\\n/g;
    const ctrlCharPattern = /\n\\f[0-9]\s/g;

    //Remove RTF Formatting, replace RTF new lines with real line breaks, and remove whitespace
    if (str != null) {
      return str
        .replace(ctrlCharPattern, "")
        .replace(basicRtfPattern, "")
        .replace(newLineSlashesPattern, "\n")
        .trim();
    }
  }

  maximizeLabResultWindow(list) {
    this.showModalLabResult = true;
    this.labResultActive = list;
  }
}
